export enum FormFieldFeedbackProvider {

    /**
     * @description Default feedback provider
     */
    Default = 'feedback',

    /**
     * @description Tooltip feedback provider
     */
    Tooltip = 'tooltip'
}

/**
 * @description Feedback provider type
 * @example
 * const feedbackProvider: FormFieldFeedbackProviderType = 'feedback' | 'tooltip'
 */
export type FormFieldFeedbackProviderType = 'feedback' | 'tooltip';

/**
 * @description Feedback provider type
 * @example
 * const feedbackProvider: IFormFieldFeedbackProvider = 'feedback' | 'tooltip'
 * const feedbackProvider: IFormFieldFeedbackProvider = FormFieldFeedbackProvider.Feedback
 * const feedbackProvider: IFormFieldFeedbackProvider = FormFieldFeedbackProvider.Tooltip
 */
export type IFormFieldFeedbackProvider = FormFieldFeedbackProviderType | FormFieldFeedbackProvider;
